import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContableFormGroup = ({ iError, iTouched, iReadonlyInfo, setFieldValue }) => {
  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContable', '')
    setFieldValue('nombre', '')
  }, [setFieldValue])

  const onChangeCuenta = React.useCallback(
    sel => {
      setFieldValue('cuentaContable', sel.value)
      setFieldValue('nombre', sel.label)
    },
    [setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='CUENTA' htmlFor='input-cuentaContable' md={4} alignRightAt='md' />
      <Col md={8}>
        {iReadonlyInfo ? (
          <ClearInputGroup
            id='readonly-cuentaContable'
            iValue={iReadonlyInfo}
            clickClear={clickClear}
          />
        ) : (
          <Select2CuentaContable onlyAnalitica onChange={onChangeCuenta} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
